import React from 'react';
import { Redirect } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import AuthClient from '../../auth';



class LogoutComponent extends React.Component {

  componentWillMount() {
    AuthClient.logout();
    this.props.client.resetStore();
  }

  render() {
    let {fromPath} =this.props;
    if (fromPath && fromPath.indexOf('dashboard') !== -1) {
      return (
            <Redirect to="/"/>
        );
    } else {
        return (
            <Redirect to={fromPath}/>
        );
    }
  }

}

export default withApollo(LogoutComponent);


// WEBPACK FOOTER //
// ./src/components/login/logout.js